import { RefreshCw } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';

interface OutdatedStateProps {
  timeAgoText: string;
  onRefresh: () => void;
}

export const OutdatedState = ({ timeAgoText, onRefresh }: OutdatedStateProps) => {
  const { t } = useTranslation(['authenticated.settings']);

  return (
    <div className="flex items-start justify-between gap-4">
      <div className="flex flex-col gap-1">
        <h3 className="text-xs font-semibold">
          {t('authenticated.settings:pages.integrations.refreshCard.outdated.title')}
        </h3>
        <p className="text-xs text-foreground">
          {t('authenticated.settings:pages.integrations.refreshCard.outdated.subtitle')}
        </p>
      </div>
      <div className="flex shrink-0 items-center gap-2">
        <span className="text-xs text-muted-foreground">{timeAgoText}</span>
        <Button size="sm" variant="default" onClick={onRefresh}>
          <RefreshCw className="h-4 w-4" />
          {t('authenticated.settings:pages.integrations.refreshCard.outdated.action')}
        </Button>
      </div>
    </div>
  );
};
